var _defs, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170,
    height: 295,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "e",
    x1: 859.64,
    y1: 605.599,
    x2: 959.645,
    y2: 504.079,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-855 119.571)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "c",
    cx: 1110.072,
    cy: 662.032,
    fx: 1110.072,
    fy: 662.032,
    r: 96.071,
    gradientTransform: "matrix(-.00288 -.05953 .752 -.03643 -401.361 826.373)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2.61391 1.05",
    result: "blur"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    fill: "url(#c)",
    filter: "url(#d)",
    d: "M-11.714 689.571h192.143v77.857H-11.714z",
    transform: "translate(0 -450)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.635 453.784c-2.022 0-5.244.445-8.045 2.813-4.483 3.788-6.188 9.596-5.998 12.69.19 3.093.254 4.23.254 4.23l7.386 79.549 6.944 75.255 8.588 90.536s.251 10.228 8.08 15.279c7.828 5.05 13.763 1.64 13.763 1.64s1.705.381 2.174.493c.469.111 1.295.111 1.295.111l.602-.012 80.023-3.963s3.147.024 4.24-.646c1.094-.67 1.073-.09 1.073-.09s.044.649.691.649c.647 0 7.055-.737 7.055-.737s6.01-.223 10.24-6 2.903-10.828 2.84-11.554c-.063-.726-.246-1.977-.246-1.977l-4.11-34.926L137.572 545.6l-8.215-65.67s-.446-4.91-4.375-9.375c-3.928-4.464-9.822-5.179-11.34-5.358-1.517-.178-2.902-.378-2.902-.378l-83.777-10.053-8.334-.82s-.781-.16-1.994-.16zm-1.236 12.404c.294 0 .598.018.91.051 2.5.268 4.106.357 4.106.357l99.171 10.715s2.768 0 4.643 1.785c1.875 1.786 3.035 3.84 3.392 7.143.358 3.304.446 4.197.446 4.197l6.622 55.833 7.731 64.856 6.392 55.18 4.843 40.28s1.072 4.464-.267 6.16c-1.34 1.697-3.214 2.59-7.053 2.768a899.1 899.1 0 00-5.537.27L65.6 718.512l-23.75.894s-4.822.09-6.43-1.964c-1.607-2.054-2.32-1.608-2.855-7.59-.536-5.982-.715-7.858-.715-7.858L24.13 628.82l-6.34-64.852-6.428-69.82-1.571-20.409s-.893-3.927.625-5.445c1.328-1.328 2.93-2.11 4.984-2.106z",
    fill: "url(#e)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.55 454.966c-4.587-.149-7.071.984-9.728 3.758-3.035 3.17-1.25 14.107-1.25 14.107l5.178 56.383 4.865 52.635 4.465 47.097 4.867 50.49 3.48 34.688s.136 1.743.27 3.082c.134 1.34.222 6.785 3.838 11.338 3.616 4.554 10.715 4.867 10.715 4.867l20.938-.715 36.517-1.74 41.117-2.144s.58 0 2.813-.223c2.232-.223 5.847-1.384 8.66-5.357 2.812-3.974 1.428-12.188 1.428-12.188l-2.229-20.219-3.976-33.486-4.153-34.777-4.195-34.418-4.063-32.903-3.705-29.822-5.267-40.445s-.135-.537-.492-4.867c-.358-4.33-2.366-6.963-5.803-10.4-3.438-3.438-8.125-3.663-8.125-3.663l-6.027-.67-22.768-2.767-58.438-6.74s-.848-.18-6.83-.76a32.807 32.807 0 00-2.101-.141zm-1.888 12.232c.294.001.598.018.91.051 2.5.268 4.106.358 4.106.358l96.52 10.714s2.767 0 4.642 1.786c1.875 1.785 3.035 3.839 3.392 7.142.358 3.304.446 4.197.446 4.197l6.875 54.823 7.857 64.73 6.518 55.18 4.465 39.017s1.071 4.464-.268 6.16c-1.34 1.697-3.213 2.59-7.053 2.768a899.1 899.1 0 00-5.537.27l-73.303 2.855-23.75.895s-4.822.088-6.43-1.965c-1.606-2.054-2.319-1.608-2.855-7.59-.535-5.982-.715-7.857-.715-7.857l-6.964-71.786-6.34-65.357-6.428-69.82-1.697-19.02s-.893-3.927.625-5.445c1.328-1.328 2.93-2.11 4.984-2.106z",
    fill: "#1a1a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.454 510.702l1.2 13.89s.224 1.563-.94 1.574c-.694-.157-.607-2.048-.86-4.257l-.252-2.21-.758-7.702s-.028-1.945 1.136-1.705c.269.055.474.41.474.41zM9.284 531.06l1.2 13.89s.225 1.562-.94 1.574c-.694-.158-.607-2.048-.86-4.258l-.252-2.21-.758-7.702s-.028-1.945 1.137-1.705c.268.055.473.41.473.41z",
    fill: "gray",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -11.988,
    cy: 464.646,
    rx: 2.368,
    ry: 2.377,
    transform: "skewX(5) scale(1 .99619)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "skewX(5) scale(1 .99619)",
    ry: 1.305,
    rx: 1.3,
    cy: 466.737,
    cx: 10.793,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.905,
    cy: 467.185,
    rx: 1.3,
    ry: 1.305,
    transform: "skewX(5) scale(1 .99619)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.929 464.795s-1.161-.09-1.25.982c-.09 1.071.535 1.428 1.071 1.473.536.045 1.116.134 1.116.134l12.366 1.562s1.206.179 1.25-.892c.045-1.072-1.071-1.518-2.187-1.652a57.659 57.659 0 01-1.697-.223z",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "skewX(5) scale(1 .99619)",
    ry: 1.305,
    rx: 1.3,
    cy: 473.19,
    cx: 65.632,
    fill: "#333"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.55 4.966c-4.587-.149-7.071.984-9.728 3.758-3.035 3.17-1.25 14.107-1.25 14.107l5.178 56.383 4.865 52.635 4.465 47.097 4.867 50.49 3.48 34.688s.136 1.743.27 3.082c.134 1.34.222 6.785 3.838 11.338 3.616 4.554 10.715 4.867 10.715 4.867l20.938-.715 36.517-1.74 41.117-2.144s.58 0 2.813-.223L32.824 6.483l-5.342-.617s-.848-.179-6.83-.76a32.807 32.807 0 00-2.101-.14z",
    opacity: 0.1,
    fill: "#999",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.88d15f915d054901b7f27faed15c8132.svg";
export { ForwardRef as ReactComponent };